// Реквизиты и версии юридических документов — единственный источник правды.
// Меняется здесь: подвал сайта, оферта, политика ПДн, cookies, правила
// рекомендательных технологий и чеки ссылаются на эти же значения.
// Проверено по выписке из ЕГРИП от 20.09.2026 (ИЭ9965-26-115865898).

export const OPERATOR = {
  // В документах — полностью, как в ЕГРИП.
  fullName: 'Индивидуальный предприниматель Худышин Александр Леонидович',
  shortName: 'ИП Худышин А. Л.',
  ogrnip: '319774600123171',
  inn: '772370165163',
  registeredAt: '25.02.2019',
  // Адрес регистрации ИП. В ЕГРИП он скрыт, указывается оператором
  // самостоятельно — нужен в оферте как адрес для претензий. Решение
  // пользователя 21.09: полностью — только в оферте, в остальных документах —
  // город; телефон не публикуем, для связи хватает почты.
  address: '109559, Россия, г. Москва, Ставропольская улица, д. 50/22, кв. 50',
  city: 'г. Москва',
  email: 'support@turkido.ru',
  site: 'https://turkido.ru',
  // УСН «доходы» 6%. Отсюда Taxation в чеке (lib/payments) и строка про НДС.
  taxNote: 'Применяется упрощённая система налогообложения. НДС не облагается (п. 2 ст. 346.11 НК РФ).',
} as const

// Версия = дата последней редакции текста. При правке документа поднять дату:
// именно она попадает в consents.doc_version и доказывает, с чем согласились.
export const DOC_VERSIONS = {
  offer: '2026-10-25',
  privacy: '2026-10-06',
  cookies: '2026-10-06',
  recsys: '2026-09-21',
} as const

export type DocKey = keyof typeof DOC_VERSIONS

export const DOC_TITLES: Record<DocKey, string> = {
  offer: 'Публичная оферта',
  privacy: 'Политика обработки персональных данных',
  cookies: 'Политика использования cookie',
  recsys: 'Правила применения рекомендательных технологий',
}

export const DOC_PATHS: Record<DocKey, string> = {
  offer: '/legal/offer',
  privacy: '/legal/privacy',
  cookies: '/legal/cookies',
  recsys: '/legal/recsys',
}

// Возраст, с которого можно заключить договор самостоятельно (ст. 26 ГК РФ).
export const MIN_AGE = 14
